// extracted by mini-css-extract-plugin
export default {"root":"root__7kUSm","fadeInAnimation":"fadeInAnimation__Ai-eA","heading":"heading__SPSyb","hideContent":"hideContent__5fBb0","fadeOutAnimation":"fadeOutAnimation__cV-4e"};